/* eslint-disable jsx-a11y/control-has-associated-label */
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import OutsideClickHandler from 'react-outside-click-handler';
import { Button } from 'Shared/Button';
import { ButtonRow } from 'Shared/ButtonRow';
import { Close } from '../../Icons';
import styles from './modal.module.css';

interface ModalProps {
    actionCallback?: () => void;
    actionText?: string;
    cancelCallback: () => void;
    cancelText?: string;
    disable?: boolean;
    header?: string;
    hideHeader?: boolean;
    children: React.ReactElement | React.ReactElement[];
    modalWidth?: React.CSSProperties;
    showActionButton?: boolean;
    showCancelButton?: boolean;
}

function ModalWithAction({
    cancelCallback,
    actionCallback,
    actionText,
    cancelText,
    disable,
    children,
    header = '',
    hideHeader = false,
    modalWidth,
    showActionButton = true,
    showCancelButton = true,
}: ModalProps): JSX.Element {
    const { t } = useTranslation(['buttons']);

    const actionButtonLabel = actionText || t('buttons:confirm');
    const cancelButtonLabel = cancelText || t('buttons:cancel');

    const isFullWidth = !showCancelButton || !showActionButton;

    return (
        <div className={styles.Modal}>
            <OutsideClickHandler onOutsideClick={cancelCallback}>
                <div className={styles.ModalContent} style={modalWidth}>
                    {!hideHeader && (
                        <div className={styles.ModalHeader}>
                            <h2>{header}</h2>
                            {cancelCallback && (
                                <button
                                    type="button"
                                    onClick={cancelCallback}
                                    style={{ border: 'none', backgroundColor: 'rgba(0, 0, 0, 0.0)' }}
                                >
                                    <div className={styles.ModalHeaderIcon}>
                                        <Close aspect="1.5rem" />
                                    </div>
                                </button>
                            )}
                        </div>
                    )}
                    {children}
                    <ButtonRow
                        withMarginTop
                        withMarginBottom
                        fullWidth={isFullWidth}
                        style={{
                            paddingLeft: isFullWidth ? '.5rem' : '0',
                            paddingRight: isFullWidth ? '.5rem' : '0',
                        }}
                    >
                        {showCancelButton && (
                            <Button
                                text={cancelButtonLabel}
                                inverse
                                callback={cancelCallback}
                                style={{
                                    marginLeft: '.5rem',
                                    marginRight: showActionButton ? '.25rem' : '0.5rem',
                                    width: showActionButton ? 'auto' : '100%',
                                }}
                            />
                        )}
                        {showActionButton && (
                            <Button
                                text={actionButtonLabel}
                                callback={actionCallback}
                                style={{
                                    marginRight: '.5rem',
                                    marginLeft: showCancelButton ? '.25rem' : '0.5rem',
                                    width: showCancelButton ? 'auto' : '100%',
                                }}
                                disable={disable}
                            />
                        )}
                    </ButtonRow>
                </div>
            </OutsideClickHandler>
        </div>
    );
}

export default ModalWithAction;
